import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { IBanner } from '~/src/api/content/banners';
import AdvantagesBlock from '~/src/components/BlockInternet/AdvantagesBlock';
import { AddOpportunities, IRepresentTopProps } from '~/src/features/internet/internet-represent/page-blocks/AddOpportunities';
import { Questions } from '~/src/features/internet/internet-represent/page-blocks/Questions';
import { TState } from '~/src/store';

import BannerWithRoutersCard from './pageBlocks/BannerWithRoutersCard';
import CallBackFormRouters from './pageBlocks/CallBackFormRouters';
import Header from './pageBlocks/Header';
import Routers from './pageBlocks/Routers';
import RoutersBanners from './pageBlocks/RoutersBanners';
import { faqData, routersAdvs } from './data';

import { BlockTitle, BlockWrapper } from './styled';
export interface IProps {
    city: ICurrentCity,
    productList: IEquipment[],
    addOpportunities: IRepresentTopProps['addOpportunities'] | null,
    routersBanners: IBanner[] | null,
    banners: IBanner[],
}

export interface ISelectedOption {
    label: string,
    operType: string,
    price: number | string,
    pricePromo?: number | string,
    sort: number,
    type: number | string,
    value: number | string,
}

const Equipment = ({
    city,
    productList,
    addOpportunities,
    routersBanners,
    banners,
}: IProps): JSX.Element => {
    const { cityIn } = city;

    const routersRef = useRef<HTMLDivElement>(null);

    const { isAuth, clientPersonal } = useSelector((state: TState) => state.auth);

    return (
        <WideContainer>
            <Header cityIn={cityIn} routersRef={routersRef}/>
            {!!routersBanners?.length && <BlockWrapper>
                <BlockTitle>Приятные бонусы при покупке роутера</BlockTitle>
                <RoutersBanners routersBanners={routersBanners}/>
            </BlockWrapper>}
            <BlockWrapper ref={routersRef}>
                <BlockTitle withCarousel={true}>Wi-Fi роутеры и&nbsp;не&nbsp;только</BlockTitle>
                <Routers routers={productList} data-test='router-list'/>
            </BlockWrapper>

            <BlockWrapper>
                <BlockTitle>Роутеры для любых задач</BlockTitle>
                <BannerWithRoutersCard banners={banners}/>
            </BlockWrapper>
            <BlockWrapper>
                <BlockTitle withCarousel={true}>Роутеры для надёжных отношений с&nbsp;интернетом</BlockTitle>
                <AdvantagesBlock incomingData={routersAdvs}/>
            </BlockWrapper>
            <CallBackFormRouters isAuth={isAuth} agreement={clientPersonal?.agreement}/>
            {addOpportunities &&
                <AddOpportunities addOpportunities={addOpportunities}/>
            }
            <Questions title={<BlockTitle>Если остались вопросы</BlockTitle>} questions={faqData}/>
        </WideContainer>
    );
};

export default Equipment;
